export default "__VITE_ASSET__58cfef8c__"